import { Button, Link, Typography } from 'omakase';
import { FC } from 'react';
import { IconCrossCircle } from '@tock/icons';
import { ReceiptButtonProps } from 'components/business/receipts/ReceiptActionButtons';

const ReceiptCancelButton: FC<ReceiptButtonProps> = ({ variant = 'button', ...rest }) => {
  return variant === 'button' ? (
    <Button
      variant="basic"
      size="medium"
      iconStart={<IconCrossCircle />}
      data-testid="cancel-booking"
      fullWidth
      {...rest}
    >
      Cancel
    </Button>
  ) : rest.disabled ? (
    <Typography color="fgDisabled">Cancel reservation</Typography>
  ) : (
    <Typography color="fgDangerBase">
      <Link data-testid="cancel-booking" color="inherit" {...rest}>
        Cancel reservation
      </Link>
    </Typography>
  );
};

export default ReceiptCancelButton;
